import { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Checkbox } from "../components/ui/checkbox";

export const InfoStep = ({ formData, onChange, consentAccepted, onConsentChange, error }) => {
  const { t } = useLanguage();
  const [touched, setTouched] = useState(false);

  const set = (field) => (e) => onChange({ ...formData, [field]: e.target.value });

  return (
    <div data-testid="booking-info-step">
      <h2 className="font-serif text-2xl text-white mb-6">{t("booking.steps.info")}</h2>
      <div className="space-y-5 max-w-md">
        <div>
          <Label htmlFor="customer-name" className="text-white/70 text-sm">{t("booking.form.name")}</Label>
          <Input
            id="customer-name"
            data-testid="booking-name-input"
            value={formData.customer_name}
            onChange={set("customer_name")}
            placeholder={t("booking.form.namePlaceholder")}
            className="bg-[#1A1A1A] border-white/10 text-white focus:border-gold rounded-none mt-1.5"
            onBlur={() => setTouched(true)}
          />
        </div>
        <div>
          <Label htmlFor="customer-email" className="text-white/70 text-sm">{t("booking.form.email")}</Label>
          <Input
            id="customer-email"
            type="email"
            data-testid="booking-email-input"
            value={formData.customer_email}
            onChange={set("customer_email")}
            placeholder={t("booking.form.emailPlaceholder")}
            className="bg-[#1A1A1A] border-white/10 text-white focus:border-gold rounded-none mt-1.5"
            onBlur={() => setTouched(true)}
          />
        </div>
        <div>
          <Label htmlFor="customer-phone" className="text-white/70 text-sm">{t("booking.form.phone")}</Label>
          <Input
            id="customer-phone"
            data-testid="booking-phone-input"
            value={formData.customer_phone}
            onChange={set("customer_phone")}
            placeholder={t("booking.form.phonePlaceholder")}
            className="bg-[#1A1A1A] border-white/10 text-white focus:border-gold rounded-none mt-1.5"
            onBlur={() => setTouched(true)}
          />
        </div>
        <div>
          <Label htmlFor="customer-notes" className="text-white/70 text-sm">{t("booking.form.notes")}</Label>
          <Textarea
            id="customer-notes"
            data-testid="booking-notes-input"
            value={formData.notes}
            onChange={set("notes")}
            placeholder={t("booking.form.notesPlaceholder")}
            className="bg-[#1A1A1A] border-white/10 text-white focus:border-gold rounded-none mt-1.5"
          />
        </div>
        <div className="flex items-start gap-3 pt-2">
          <Checkbox
            id="consent-checkbox"
            data-testid="booking-consent-checkbox"
            checked={consentAccepted}
            onCheckedChange={onConsentChange}
            className="mt-0.5 border-white/30 data-[state=checked]:bg-gold data-[state=checked]:border-gold"
          />
          <Label htmlFor="consent-checkbox" className="text-white/70 text-sm leading-relaxed cursor-pointer">
            {t("booking.consent.text")} <Link to="/algemene-voorwaarden" target="_blank" className="text-gold underline">{t("booking.consent.terms")}</Link>{" "}
            {t("booking.consent.and")} <Link to="/privacybeleid" target="_blank" className="text-gold underline">{t("booking.consent.privacy")}</Link>.
          </Label>
        </div>
        {error && touched && <p data-testid="booking-info-error" className="text-red-400 text-sm">{error}</p>}
      </div>
    </div>
  );
};
